import { Box } from "@mui/material";
import ContentWrap from "@/DocLayout/Content/Index";
import { SWAP_COIN_LIST } from "@/config";
import CodeSnippet from "@/components/CodeSnippet";
import Table from "@/DocLayout/Table";
import { useLocales } from "@/locales";
import { CommonWrap } from "../common";
import { ChooseCodeLanguageContext } from "@/components/ChooseCodeLanguage/ChooseCodeLanguage";
import { useContext } from "react";
import { codeMap } from "@/PageCodeComponents/PublicResourceApi";
import PostRequest from "@/components/PostRequest";
export default function Index() {
  const { translate } = useLocales();
  const { language } = useContext(ChooseCodeLanguageContext);
  return (
    <div>
      {/* 获取换币代币列表 */}
      <ContentWrap
        id="get-swap-coin-list"
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box className="title_0">
              {translate("public_resource.get_swap_coin_list")}
            </Box>
            <Box className="desc">
              {translate("public_resource.get_swap_coin_list_desc")}
            </Box>
            <Box className="title_1">{translate("common.http_request")}</Box>
            <Box className="desc link">
              <PostRequest url={SWAP_COIN_LIST} />
            </Box>
            <Box className="title_1">{translate("common.http_params")}</Box>
            <Table
              isEmpty={true}
              isEmptyText={translate("common.no_requset_param")}
              tableData={[]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={codeMap["swap_coin_list"][language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取法定货币列表 返回 */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data.coins",
                  type: "Object",
                  desc: "",
                },
                {
                  name: "data.coins[index].coinId",
                  type: "Integer",
                  desc: `${translate(
                    "public_resource.get_coin_list_res_table_desc1"
                  )}`,
                },
                {
                  name: "data.coins[index].symbol",
                  type: "String",
                  desc: `${translate(
                    "public_resource.get_coin_list_res_table_desc2"
                  )}`,
                },
                {
                  name: "data.coins[index].logoUrl",
                  type: "String",
                  desc: `${translate(
                    "public_resource.get_coin_list_res_table_desc3"
                  )}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["swap_coin_list"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
    </div>
  );
}
